// @flow

import React from 'react';
import styled, { css } from 'styled-components';
import Button from '../../button';
import type { Theme } from '../../../types';

type Props = {
  collapsed: ?boolean,
  caret?: boolean, // eslint-disable-line react/require-default-props
};

const StyledButton = styled<typeof Button, Theme, Props>(Button)`
  padding-right: 0;
  padding-left: 0;
  margin-top: 1em;

  ${props => props.caret && css`
    &:after {
      transform: rotateZ(-45deg) translate(4px, 4px);

      ${!props.collapsed && css`
        transform: rotateZ(-225deg) translate(-2px, -5px);
      `}
    }
  `}
`;

const CollapseButton = (props: Props) => (
  <StyledButton
    {...props}
    caret
    variant="link_text"
    hasMargin={false}
  />
);

export default CollapseButton;
